'use client'

import React from 'react'
import styles from './sliderInput.module.scss'

const formatCurrency = (value: number) => `₹${value.toLocaleString('en-IN')}`

interface SliderInputProps {
  data: any
  value?: number
  onChange?: (value: number) => void
}

const SliderInput = ({ data, value, onChange }: SliderInputProps) => {
  const { label, suggestLabel, defaultValue, minValue, maxValue, step = 500 } = data
  const currentValue = value !== undefined ? value : defaultValue
  const percent = ((currentValue - minValue) / (maxValue - minValue)) * 100

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value)
    if (onChange) {
      onChange(newValue)
    }
  }

  const sliderStyle: React.CSSProperties & Record<string, string> = { '--progress': `${percent}%` }

  return (
    <div className={styles.sliderInputContainer}>
      <div className={styles.labelRow}>
        <div className={styles.labelContainer}>
          <p className={styles.label}>{label}</p>
          <p className={styles.subLabel}>({suggestLabel})</p>
        </div>
        <div className={styles.valueDisplay}>{formatCurrency(currentValue)}</div>
      </div>
      <div className={styles.sliderWrapper}>
        <div className={styles.sliderTrack}>
          <input
            type="range"
            className={styles.slider}
            value={currentValue}
            min={minValue}
            max={maxValue}
            step={step}
            onChange={handleChange}
            style={sliderStyle}
          />
        </div>
        <div className={styles.sliderLabels}>
          <span className={styles.minLabel}>{formatCurrency(minValue)}</span>
          <span className={styles.maxLabel}>{formatCurrency(maxValue)}</span>
        </div>
      </div>
    </div>
  )
}

export default SliderInput
